import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 4 tracking hook
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    if (window.gtag) {
      window.gtag('config', 'G-N20RQWJJ4M', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};

// Track custom events — non-blocking, deferred to idle time
export const trackEvent = (eventName, eventParams = {}) => {
  try {
    if (window.__IS_BOT) return; // Skip for bots — no GA loaded anyway
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  } catch (_e) { /* noop — analytics must never crash the app */ }
};

// Pre-defined event trackers
export const analytics = {
  // User actions
  signUp: (method) => trackEvent('sign_up', { method }),
  login: (method) => trackEvent('login', { method }),
  logout: () => trackEvent('logout'),
  
  // Resume actions
  createResume: (targetJob) => trackEvent('create_resume', { target_job: targetJob }),
  analyzeResume: (score) => trackEvent('analyze_resume', { ats_score: score }),
  reoptimizeResume: (previousScore, newScore) => trackEvent('reoptimize_resume', { 
    previous_score: previousScore, 
    new_score: newScore,
    improvement: newScore - previousScore 
  }),
  deleteResume: () => trackEvent('delete_resume'),
  
  // Payment actions
  viewPricing: () => trackEvent('view_pricing'),
  initiateCheckout: (plan, price) => trackEvent('begin_checkout', { 
    currency: 'USD',
    value: price,
    items: [{ item_name: plan }]
  }),
  completePayment: (plan, price) => trackEvent('purchase', {
    currency: 'USD',
    value: price,
    items: [{ item_name: plan }]
  }),
  
  // Engagement
  clickCTA: (ctaName, location, extra = {}) => trackEvent('cta_click', { cta_name: ctaName, location, ...extra }),
  shareResume: (platform) => trackEvent('share', { method: platform, content_type: 'resume' }),
};

export default analytics;
